import { useState, useRef, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const NotificationContentInput = ({
  label,
  value,
  onChange,
  modules,
  formats,
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);
  const quillRef = useRef(null); // 🔑 keep reference to Quill instance

  const handleEmojiClick = (emojiData) => {
    const editor = quillRef.current?.getEditor();
    if (editor) {
      const range = editor.getSelection(true);
      if (range) {
        // Insert emoji at current cursor
        editor.insertText(range.index, emojiData.emoji);
        // Move cursor after emoji
        editor.setSelection(range.index + emojiData.emoji.length, 0);
      } else {
        // fallback: append at the end
        editor.insertText(editor.getLength() - 1, emojiData.emoji);
      }
    }
  };

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  return (
    <div className="fieldrow" style={{ position: "relative" }} ref={pickerRef}>
      <label className="f_label">{label}</label>
      <div style={{ position: "relative" }}>
        <ReactQuill
          ref={quillRef} // 🔑 attach ref here
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
        />
        {/* Emoji toggle button */}
        <button
          type="button"
          onClick={() => setShowPicker(!showPicker)}
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            fontSize: "18px",
            zIndex: 11,
          }}
        >
          {showPicker ? "❌" : "🚢"}
        </button>
      </div>

      {showPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 12,
            top: "100%",
            right: 0,
          }}
        >
          <EmojiPicker onEmojiClick={handleEmojiClick} />
        </div>
      )}
    </div>
  );
};

export default NotificationContentInput;
